import type { paths } from '@crossbeam/openapi';

import { crossbeamApi } from '@/api';
import type {
  RecordQueryType,
  RecordResponseType,
  RecordSectionParamType,
} from '@/types/individual_record';
import { INDIVIDUAL_RECORD_PATH } from '@/types/individual_record';

const DEFAULT_LIMIT = 10;

type RecordQueryParamsType = NonNullable<
  paths[typeof INDIVIDUAL_RECORD_PATH]['get']['parameters']['query']
>;

function buildQuery({
  section,
  page = 1,
  limit = DEFAULT_LIMIT,
  partner_search: partnerSearch,
  partner_org_ids: partnerOrgIds,
  partner_tag_ids: partnerTagIds,
  partner_segments: partnerSegments,
  partner_score_bucket: partnerScoreBucket,
}: RecordQueryType): RecordQueryParamsType {
  const query: RecordQueryParamsType = { page, limit };
  if (section) query.section = section;
  if (partnerOrgIds?.length)
    // @ts-expect-error not in the v0.3 records spec yet
    query['partner_org_ids[]'] = partnerOrgIds;
  if (partnerSearch)
    // @ts-expect-error not in the v0.3 records spec yet
    query.partner_search = partnerSearch;
  if (partnerTagIds?.length)
    // @ts-expect-error not in the v0.3 records spec yet
    query['partner_tag_ids[]'] = partnerTagIds;
  if (partnerScoreBucket?.length)
    // @ts-expect-error not in the v0.3 records spec yet
    query['partner_score_bucket[]'] = partnerScoreBucket;
  if (partnerSegments?.length)
    // @ts-expect-error not in the v0.3 records spec yet
    query['segment[]'] = partnerSegments;
  return query;
}

export async function fetchIndividualRecord<
  Section extends RecordSectionParamType = 'all',
>(sourceId: number, sourcePrimaryKey: string, params: RecordQueryType = {}) {
  const result = await crossbeamApi.GET(INDIVIDUAL_RECORD_PATH, {
    params: {
      path: { 'source-id': sourceId, 'source-primary-key': sourcePrimaryKey },
      query: buildQuery(params),
    },
  });
  return {
    ...result,
    data: result.data as RecordResponseType<Section> | undefined,
  };
}

export function fetchActivityTimeline(
  sourceId: number,
  masterId: string,
  { page = 1, limit = DEFAULT_LIMIT }: { page?: number; limit?: number } = {},
) {
  return crossbeamApi.GET('/v0.1/activity-timeline/{source_id}/{master_id}', {
    params: {
      path: { source_id: sourceId, master_id: masterId },
      query: { page, limit },
    },
  });
}
